import type { Patient } from '../api/patientApi';

export type UserRoleName = string | undefined;
export type FlowProgramType = Patient['programType'];

export const isAdminRole = (roleName: UserRoleName) => (
  roleName === 'ADMINISTRATOR' || roleName === 'ADMIN' || roleName === 'SUPER_ADMIN'
);

export const isDermatoRole = (roleName: UserRoleName) => roleName === 'DERMATOLOG';

export const isHepatoRole = (roleName: UserRoleName) => (
  roleName === 'HEPATOLOG' || roleName === 'GASTROENTEROLOG'
);

/**
 * Echipa clinică a fiecărui flux (oglindă pentru packages/common/src/flows;
 * drepturile reale pe pas vin de la server prin GET .../:id/flow).
 */
const DERMATO_TEAM = ['ASISTENT', 'DERMATOLOG', 'CHIRURG', 'ONCOLOG', 'ANATOMOPATOLOG'];
const HEPATO_TEAM = ['ASISTENT', 'HEPATOLOG', 'GASTROENTEROLOG', 'CHIRURG', 'ONCOLOG', 'ANATOMOPATOLOG', 'RADIOLOG'];

export const canUseDermato = (roleName: UserRoleName) => (
  isAdminRole(roleName) || (roleName !== undefined && DERMATO_TEAM.includes(roleName))
);

export const canUseHepato = (roleName: UserRoleName) => (
  isAdminRole(roleName) || (roleName !== undefined && HEPATO_TEAM.includes(roleName))
);

export const getRoleProgramType = (roleName: UserRoleName): FlowProgramType | undefined => {
  if (isDermatoRole(roleName)) {
    return 'DERMATO';
  }

  if (isHepatoRole(roleName)) {
    return 'HEPATO';
  }

  return undefined;
};

export const getProgramOptionsForRole = (roleName: UserRoleName) => {
  if (isDermatoRole(roleName)) {
    return [{ value: 'DERMATO' as const, label: 'Dermato' }];
  }

  if (isHepatoRole(roleName)) {
    return [{ value: 'HEPATO' as const, label: 'Hepato' }];
  }

  // Rolurile de specialitate (chirurg, oncolog, anatomopatolog, radiolog) nu înrolează pacienți.
  if (!isAdminRole(roleName) && roleName !== 'ASISTENT') {
    return [];
  }

  return [
    { value: 'DERMATO' as const, label: 'Dermato' },
    { value: 'HEPATO' as const, label: 'Hepato' },
    { value: 'BOTH' as const, label: 'Ambele' },
  ];
};
